import React, { useEffect, useMemo } from "react";
import { useTable, useSortBy } from "react-table";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../Pagination Component/paginationAndSearching";
import { TableLoading } from "react-bootstrap-table-loading";
import SkeletonTableRow from "../../SkeltonTable/skeletonTable";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { currencyFormat, formatDate } from "../../../../function/commonFunction";
//import './table.css';
import { Button, Menu, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import ExpiryDateFilter from "../../../pages/propertyList/ExpiryDateFilter";
import { findSubMenuByName } from "../../../pages/propertyList/MenuUtlis";

export const UnIdentifiedBillsTable = ({
  column,
  rowsArr,
  handleActionPending,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  totalCount,
  onLoadData,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  setPageSizeUnBills,
  setFilterType
}) => {
  const { permissionArr } = useSelector((state) => state.auth);
  const { permissions } = useSelector((state) => state.permissionsData);

  const navigate = useNavigate();

  const columns = useMemo(() => column, [column]);
  const data = useMemo(() => rowsArr, [rowsArr]);

  const tableInstance = useTable({ columns, data }, useSortBy);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    //footerGroups,
    rows,
    prepareRow,
  } = tableInstance;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  function handleGoToView(view) {
    // console.log(view);
    localStorage.setItem("FilePath", view.FilePath);
    navigate("/pdfView");
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

// Helper function to check if a specific action exists in a submenu
const hasAction = (submenu, actionName) => submenu?.Actions.includes(actionName);

// Find the "Invoice" menu
const propertiesMenu = findSubMenuByName(permissions, 'Invoice');
const listPropertyMenu = propertiesMenu ? findSubMenuByName(propertiesMenu?.SubMenus, 'Invoice List') : null;
const approvedSubMenu = listPropertyMenu ? findSubMenuByName(listPropertyMenu?.SubMenus, 'Unidentified Invoices') : null;
// Check actions in the "Unidentified Invoices" submenu
const canApprove = approvedSubMenu ? hasAction(approvedSubMenu, 'Approve') : false;
const canSearch = approvedSubMenu ? hasAction(approvedSubMenu, 'Search') : false;
const canMoreFilter = approvedSubMenu ? hasAction(approvedSubMenu, 'MoreFilter') : false;
const canAudittrial = approvedSubMenu ? hasAction(approvedSubMenu, 'Audittrial') : false;
const canEdit = approvedSubMenu ? hasAction(approvedSubMenu, 'Edit') : false;
const canReject = approvedSubMenu ? hasAction(approvedSubMenu, 'Reject') : false;
const canAssignUsers = approvedSubMenu ? hasAction(approvedSubMenu, 'AssignUsers') : false;
const canView = approvedSubMenu ? hasAction(approvedSubMenu, 'View') : false;
const canGenerateOutputFile = approvedSubMenu ? hasAction(approvedSubMenu, 'GenerateOutputFile') : false;
const canUploadReverseFile = approvedSubMenu ? hasAction(approvedSubMenu, 'UploadReverseFile') : false;
const MoreFilterSubMenu = approvedSubMenu ? findSubMenuByName(approvedSubMenu?.SubMenus, 'MoreFilters') : null;
const invoiceType = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'InvoiceType') : false;
const expiryDate = MoreFilterSubMenu ? hasAction(MoreFilterSubMenu, 'ExpiryDate') : false;

const handlePageSizeChange=(event)=>{
  setPageSizeUnBills(event.target.value)
  }

  const [type, setTpe] = React.useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
  const handleChange = (event) => {
    setTpe(event.target.value);
  };

  useEffect(() => {
    setFilterType(type)
  }, [type])
  return (
    <>
      <div className="card">
        <div className="card-header">
          <h3></h3>
          {/* <PaginationAndSearching
                        handleSearch={handleSearchPagination}
                        searchValue={searchValuePagination}
                        defaultValue={pageSizePagination}
                        handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                        totalCount={totalCountPagination}
                        onChange={handleOnChangePagination}
                    /> */}
        </div>
        <div className="card-body">
          <h4>
            {" "}
            Total Invoices : &nbsp;
            {totalCount}
          </h4>  <div className="d-flex justify-content-end">
          {canSearch&&(
            <div className="service-input-group input-group" style={{width:"220px"}}>
                        <span className="input-group-text search-input-icon">

                            <i className="bi bi-search" style={{ fontSize: '16px' }}></i>
                        </span>
                        <input
                            type="text"
                            className="form-control search-input"
                            id="val-username1"
                            placeholder="Search..."
                            name="username"
                            value={searchValuePagination}
                            onChange={handleSearchPagination}
                        />
                    </div>
          )}
                                                      {MoreFilterSubMenu&&(
                    <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          textTransform:'none'
        }}
      >
        More Filters<span class="material-icons">
arrow_drop_down
</span>
      </Button>
                                                      )}
      <ExpiryDateFilter
 onLoadData={()=>{
  onLoadData("InvoiceList",type)
  handleClose()
}}
 open={open}
 fromDate={fromDate}
 toDate={toDate}
 setFromDate={setFromDate}
 anchorEl={anchorEl}
 handleClose={handleClose}
 setToDate={setToDate}
 type={type}
 handleChange={handleChange}
 showInvoiceType={invoiceType}
 showExpDate={expiryDate}
//  setTpe={setTpe}
 />
            </div>
          <div className="table-responsive">
        
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                        
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{ color: "rgba(23, 90, 169, 0.78)" ,
                            width:'0px',
                            padding:"10px 5px",
                            textAlign:'center',
                            whiteSpace: "normal", /* Allow text to wrap */
                            wordWrap: "breakWord", /* Break long words if necessary */
                            maxWidth: "200px", /* Adjust width as needed */
                            // textAlign: "center", /* Center the text */
                          }}
                        >
                          {column.render("Header")}
                          <span className="ml-1">
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()} style={{padding:'5px 0px',margin:0}}>
                        {row.cells.map((cell, cellIndex) => {
                          const isLastCoumn =
                            cellIndex === row.cells.length - 1;
                          const invoiceDate = cellIndex === 3;
                          const invoiceDueDate = cellIndex === 5;
                          const amount = cellIndex === 6;
                          const taxAmount = cellIndex === 7;
                          const totalAmount = cellIndex === 8;
                          const LocationCode = cellIndex === 9;
                          const shouldHideInvoiceType =
                          cell.column.accessor === "InvoiceType" && permissionArr.some(permission => permission.includes('Telephone'));
                      
                          return (
                            <td
                              {...cell.getCellProps()}
                              style={{ color: "black", whiteSpace: "normal" , padding:'7px',margin:0,textAlign:'center'}}
                            >
                              {isLastCoumn ? (
                                <>
{canEdit &&
<OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{"edit"}</Tooltip>}>
                                    <i
                                      className="material-icons"
                                      style={{
                                        color: "rgba(233, 133, 35, 0.84)",
                                        marginRight: "6px",
                                        cursor: "pointer",width:'20px',height:'20px'
                                      }}
                                      onClick={() => {
                                        handleActionPending(rows[rowIndex].original.Id, "edit", rows[rowIndex].original);
                                      }}
                                    >
                                      edit
                                    </i>
                                  </OverlayTrigger>}
                                                                      {canAudittrial&&(
                                                                      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{"Audit"}</Tooltip>}>
                                                                        <i
                                                                          className="material-icons"
                                                                          style={{
                                                                            color: "rgba(23, 90, 169, 0.78)",
                                                                            marginRight: "6px",
                                                                            cursor: "pointer",width:'18px',height:'20px'
                                                                          }}
                                                                          onClick={() => {
                                                                            handleActionPending(rows[rowIndex].original.Id, "audit", rows[rowIndex].original);
                                                                          }}
                                                                        >
                                                                          history
                                                                        </i>
                                                                      </OverlayTrigger>
                                                                    )}
                                             <OverlayTrigger
                                             placement="top"
                                             overlay={
                                               <Tooltip id="tooltip">{"veiw"}</Tooltip>
                                             }
                                           >
                                              <i
                                               className="material-icons"
                                               style={{
                                                 color: "rgba(23, 90, 169, 0.78)",
                                                 marginRight: "6px",
                                                 cursor: "pointer",width:'20px',height:'20px'
                                               }}
                                               onClick={() => {
                                                 handleGoToView(row.original);
                                               }}
                                             >
                                               visibility
                                             </i>
                                           </OverlayTrigger>
                       
                                </>
                              ) : (
                                // (invoiceDate &&
                                //   formatDate(row.original.InvoiceDate)) ||
                                // // (invoiceDueDate &&
                                // //   formatDate(row.original.InvoiceDueDate)) ||


                                // // (amount && currencyFormat(rows[rowIndex].original.Amount)) ||
                                // // (taxAmount && currencyFormat(rows[rowIndex].original.TotalTaxValue)) ||
                                // // (totalAmount && currencyFormat(rows[rowIndex].original.TotalAmount)) ||
                                // (LocationCode && cell.render("Cell")) ||

                                // cell.render("Cell")


                                (cell.column.id  === "InvoiceDate" && formatDate(rows[rowIndex].original.InvoiceDate)) ||
                                (cell.column.id  === "LocationCode" && cell.render("Cell")) ||
                                cell.render("Cell")

                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>{" "}
                {showLoading && <SkeletonTableRow cols={11} row={4} />}
              </table>

              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}
             
            </div>
          </div>
                            {/* Pagination & Page Size */}
        <div className="pagination-container d-flex justify-content-between">
          <div style={{marginTop:"20px"}}>
            <label htmlFor="pageSizeSelect">Rows per page: </label>
            <select
              id="pageSizeSelect"
              value={pageSizePagination}
              onChange={handlePageSizeChange}
              style={{ marginLeft: "10px" }}
            >
                <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={250}>250</option>
              <option value={500}>500</option>
            </select>
          </div>
          <PaginationAndSearching
                        handleSearch={handleSearchPagination}
                        searchValue={searchValuePagination}
                        defaultValue={pageSizePagination}
                        handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
                        totalCount={totalCountPagination}
                        onChange={(e,p)=>{
                          handleOnChangePagination(e,p)
                          // setCheckedRows([])
                        }}
                        
                    />
                    </div>
        </div>
      </div>
    </>
  );
};
export default UnIdentifiedBillsTable;
